export default (options) => {
  return {
    event: 'Tier Benefits',
    DepartureTime: options.flightWindow,
    familyFare: options.familyFare,
    ffProgram: options.ffProgram,
    flightType: options.flightType,
    labelFlightNumber: options.labelFlightNumber,
    pnr: options.pnrCode,
    route: options.route,
    TierCard: options.tierCard,
    TierLvl: options.tierLvl,
    TierProd: options.tierProd,
    TierTotal: options.TierTotal,
  };
};
